document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("scroll-image-slider")) {
    customElements.define(
      "scroll-image-slider",
      class ScrollFeaturedCollection extends HTMLElement {
        constructor() {
          super();
          this.tabContent = this.querySelectorAll(
            ".scroll-image-slider-content"
          );

          this.isAutoplay = this.getAttribute("data-auto-play");
          this.pageinationType = this.getAttribute("data-pageination-type");
          this.autoplayDelay = this.getAttribute("data-autoplay-delay");
        }

        connectedCallback() {
          this.initSwipers();
        }

        initSwipers() {
          console.log(
            "this ..........attr..........",
            this.isAutoplay,
            this.isShowPageination,
            this.isShowPregress
          );

          this.tabContent.forEach((item) => {
            let _sectionId = item.getAttribute("data-section-id");
            this.initSwiper(_sectionId);
          });
        }

        initSwiper(_sectionId) {

          let attrs = {
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 12,
            initialSlide: 0,
            centeredSlides: true,
            centeredSlidesBounds: true,
            breakpoints: {
              989: {
                slidesPerView: 1,
                initialSlide:0,
                spaceBetween:16,
                centeredSlides: true,
                centeredSlidesBounds: true,
              },
            },

            // 如果需要前进后退按钮
            navigation: {
              nextEl: `.swiper-button-next-${_sectionId}`,
              prevEl: `.swiper-button-prev-${_sectionId}`,
            },
          };
          console.log("aaaaa.....", this.isAutoplay);
          if (this.isAutoplay == "true") {
            console.log("autoplay::::::::::::true");
            attrs.autoplay = {
              disableOnInteraction: false,
              delay: parseInt(this.autoplayDelay) * 1000,
            };
          }
          // 如果需要分页器
          if (this.pageinationType != "no") {
            console.log("0909090", this.pageinationType);
            switch (this.pageinationType) {
              case "point":
                attrs.pagination = {
                  el: `.swiper-pagination-${_sectionId}`,
                  type: "bullets",
                  clickable: "true",
                };
                break;
              case "number":
                attrs.pagination = {
                  el: `.swiper-pagination-${_sectionId}`,
                  type: "fraction",
                };
                break;
              case "progress":
                attrs.pagination = {
                  el: `.swiper-pagination-${_sectionId}`,
                  type: "progressbar",
                };
                break;
            }
          }
          // 如果需要滚动条
          if (this.isShowPregress == "true") {
            attrs.scrollbar = {
              el: `.swiper-scrollbar-${_sectionId}`,
              type: "progressbar",
            };
          }

          console.log(attrs);

          new Swiper(`.swiper-${_sectionId}`, attrs);
        }
      }
    );
  }
});
